// this function determines what the new "current" video should be when a video is removed from a playlist. If the "current" video
// does not need to change, then null is returned.
const getNewSelectedVideoIndex = (
  videoToRemoveIdx: number,
  selectedVideoIdx: number,
  isSelectedVideoLast: boolean,
  updatedPlaylistSize: number
): number | null => {
  if (videoToRemoveIdx < selectedVideoIdx) {
    // if the video removed is before the "current" video, then we'll need to change the selected index to reflect current video's new position
    return selectedVideoIdx - 1;
  } else if (videoToRemoveIdx === selectedVideoIdx && isSelectedVideoLast && updatedPlaylistSize > 0) {
    // if we are removing the "current" video and it is last, then we'll need to change the selected index to the new last video
    return updatedPlaylistSize - 1;
  }
  // in all other cases the "current" video index does not need to change
  return null;
};

export default getNewSelectedVideoIndex;
